import { OtpType } from '@shopee-user/otp-hook-base-constants';

export { OtpType };

/**
 * https://confluence.shopee.io/pages/viewpage.action?spaceKey=SAUT&title=%5BTD%5D+ToB+Account+-+ShopeeFood+Driver
 */
export enum VcodeOperation {
  // NOT_APPLICABLE
  NOT_APPLICABLE = -1,

  // MERCHANT
  TOB_MERCHANT_LOGIN_OTP = 50000,
  TOB_MERCHANT_LOGIN_PASSWORD = 50001,
  TOB_MERCHANT_FORGOT_PASSWORD = 50002,
  TOB_MERCHANT_MIGRATE_ONE_CREDENTIAL = 50003,
  TOB_MERCHANT_OTP_SIGNUP = 50004,
  TOB_MERCHANT_SWITCH_TOC_LINK_ONE_CREDENTIAL = 50005,

  // FOODY/SHOPEEFOOD DRIVER
  TOB_FOODY_DRIVER_LOGIN_OTP = 50500,
  TOB_ACCOUNT_SHOPEEFOOD_DRIVER_OTP_SIGNUP = 50502,
  TOB_ACCOUNT_SHOPEEFOOD_DRIVER_CHANGE_PHONE = 50503,
  TOB_ACCOUNT_SHOPEEFOOD_DRIVER_CHANGE_EMAIL = 50504,
  TOB_ACCOUNT_SHOPEEFOOD_DRIVER_FORGET_PASSWORD = 50507,

  // Spx Driver
  TOB_ACCOUNT_SPX_DRIVER_OTP_LOGIN = 51000,
  TOB_ACCOUNT_SPX_DRIVER_PASSWORD_NEW_DEVICE_LOGIN = 51001,
  TOB_ACCOUNT_SPX_DRIVER_FORGET_PASSWORD = 51002,
  TOB_ACCOUNT_SPX_DRIVER_WALLET_PIN_NEW = 51003,
  TOB_ACCOUNT_SPX_DRIVER_WALLET_PIN_RESET = 51004,
  TOB_ACCOUNT_SPX_DRIVER_ACCOUNT_UPDATE = 51006,
  TOB_ACCOUNT_SPX_DRIVER_CHANGE_PHONE = 51007,
  TOB_ACCOUNT_SPX_DRIVER_OTP_SIGNUP = 51008,

  // SPX SELLER
  TOB_ACCOUNT_SPX_SELLER_OTP_SIGNUP = 51500,
  TOB_ACCOUNT_SPX_SELLER_FORGET_PASSWORD = 51501,
  TOB_ACCOUNT_SPX_SELLER_ADD_PHONE = 51502,
  TOB_ACCOUNT_SPX_SELLER_ADD_EMAIL = 51503,
  TOB_ACCOUNT_SPX_SELLER_OTP_LOGIN = 51504,
  TOB_ACCOUNT_SPX_SELLER_PASSWORD_NEW_DEVICE_LOGIN = 51505,
  TOB_ACCOUNT_SPX_SELLER_MIGRATE_ONE_CREDENTIAL = 51506,
  TOB_ACCOUNT_SPX_SELLER_ONE_CREDENTIAL_DELINK_OTP = 51509,

  // SLS: 52000~52999
  TOB_ACCOUNT_SLS_OTP_LOGIN = 52000,

  // Brand IP
  TOB_ACCOUNT_BRAND_IP_OTP_SIGNUP = 52500,
  TOB_ACCOUNT_BRAND_IP_FORGET_PASSWORD = 52501,

  // Open Platform
  TOB_ACCOUNT_OPEN_PLATFORM_OTP_SIGNUP = 53000,
  TOB_ACCOUNT_OPEN_PLATFORM_FORGET_PASSWORD = 53001,

  // Partner Voucher
  TOB_ACCOUNT_PARTNER_VOUCHER_MANAGEMENT_OTP_SIGNUP = 53500,

  // SPX Agency Portal
  TOB_ACCOUNT_SPX_AGENCY_FORGET_PASSWORD = 54000,

  // Direct Delivery
  TOB_ACCOUNT_DIRECT_DELIVERY_OTP_SIGNUP = 54500,
  TOB_ACCOUNT_DIRECT_DELIVERY_OTP_LOGIN = 54501,
  TOB_ACCOUNT_DIRECT_DELIVERY_PASSWORD_NEW_DEVICE_LOGIN = 54502,

  // Sandbox
  TOB_ACCOUNT_SANDBOX_OTP_SIGNUP = 102500,
  TOB_ACCOUNT_SANDBOX_OTP_LOGIN = 102501,
  TOB_ACCOUNT_SANDBOX_OTP_PASSWORD_NEW_DEVICE_LOGIN = 102502,
  TOB_ACCOUNT_SANDBOX_FORGET_PASSWORD = 102503,
  TOB_ACCOUNT_SANDBOX_ACCOUNT_UPDATE = 102504,
  TOB_ACCOUNT_SANDBOX_CHANGE_PHONE = 102505,
  TOB_ACCOUNT_SANDBOX_CHANGE_EMAIL = 102506,
  TOB_ACCOUNT_SANDBOX_ADD_PHONE = 102507,
  TOB_ACCOUNT_SANDBOX_ADD_EMAIL = 102508,

  // IVS
  TOB_ACCOUNT_SHOPEEFOOD_DRIVER_IVS_LOGIN_EMAIL_OTP = 50505,

  // Partner Delink
  TOB_ACCOUNT_SHOPEEPAY_MERCHANT_DELINK = 50008,
}
